import { createOverlayComponent } from './createOverlayComponent';
var IonActionSheet = createOverlayComponent('ion-action-sheet', 'ion-action-sheet-controller');
export default IonActionSheet;